<template>
  <div
    class="popular-registry-gifts medium-margin-top-l small-margin-top-s"
    :style="{ left: `-${targetLeftMargin - myGiftWidth?.leftVal}px`, width: `${myGiftWidth?.widthVal}px` }"
  >
    <div v-if="!popularItems" class="h3 popular-registered-items-header">More Like This</div>
    <div class="cell small-12" :class="{ 'pros-collection-hide': !popularItems }">
      <!-- Zone_B is popular items and Zone_A is similar products -->
      <ProsCollection :panel-config="panelConfig" :recommendation-config="recommendationConfig" />
    </div>
  </div>
</template>

<script setup>
import ProsCollection from '@nuxt-common/pros-collection/app/components/ProsCollection.vue';

const props = defineProps({
  popularItems: {
    type: Boolean,
    required: true,
  },
  productId: {
    type: Number,
    default: -9,
    required: false,
  },
  imageId: {
    type: Number,
    required: false,
    default: null,
  },
  targetLeftMargin: {
    type: Number,
    required: false,
    default: null,
  },
  myGiftWidth: {
    type: Object,
    required: false,
    default: null,
  },
  isLanding: {
    type: Boolean,
    default: false,
    required: false,
  },
  isBabyLanding: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const isBabyRegistry = computed(() => {
  try {
    const registriesObject = JSON.parse(window.localStorage.getItem('userRegistries'));
    const defaultRegistry = registriesObject.registries.find((registry) => registry.defaultRegistry);
    return defaultRegistry.occasionType.toUpperCase() === 'BABY';
  } catch {
    return false;
  }
});

const dataContextValue = computed(() => {
  if (props.popularItems) {
    if ((!props.isLanding && isBabyRegistry.value) || (props.isLanding && props.isBabyLanding)) {
      return 'REG_ZONE_C';
    }
    return 'REG_ZONE_B';
  }
  return 'REG_ZONE_A';
});

const recommendationConfig = computed(() => ({
  zone: dataContextValue.value,
  productId: props.productId,
  imageId: props.imageId,
}));

const panelConfig = computed(() => ({
  title: '',
}));
</script>

<style lang="scss" scoped>
.popular-registry-gifts {
  width: 100%;
  position: relative;
}

@include breakpoint(medium up) {
  .category {
    width: rem-calc(236);
  }
}

@include breakpoint(small down) {
  .category {
    width: rem-calc(160);
  }

  .category-container.grid-margin-x > .cell {
    margin: 0 rem-calc(4);
  }
}

.category-container {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  flex-flow: nowrap;
}
</style>

<style lang="scss" brand="bcom" scoped>
.popular-registered-items-header {
  text-transform: uppercase;
}
</style>

<style>
.pros-collection-hide h3 {
  display: none;
}
</style>
